import { all, put, takeLatest } from "redux-saga/effects";
import { RUN_PIPELINE_SUCCESS } from "../actions/pipeline";
import { queryPatientHLAEngineResults } from "../actions/hla-engine";
import { queryPatientHLASynthesis } from "../actions/hla-synthesis";


export function* execRuleEnginePipelineSaga(): Generator<any, any, any> {
  yield all([
    // On "exec-rule-engine" pipeline success, automatically refresh patient hla data
    takeLatest((action) => action.type === RUN_PIPELINE_SUCCESS && action.name === 'exec-rule-engine', refresPatientHLAData)
  ]);
}

function* refresPatientHLAData(
  action
): Generator<any, any, any> {

  if (!action.input?.inlogId) return;

  const inlogId: string = action.input?.inlogId;

  yield put(queryPatientHLAEngineResults(inlogId))
  yield put(queryPatientHLASynthesis(inlogId))
}